var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxtf-tooltip",
    {
      class: [_vm.fromHor ? "ellipsis-2" : "ellipsis"],
      attrs: { placement: "top", "open-filter": "" },
    },
    [
      _c(
        "div",
        {
          style: { "max-width": _vm.rankWidth + "px" },
          attrs: { slot: "content" },
          slot: "content",
        },
        [_c("content-name", { attrs: { code: _vm.code, name: _vm.name } })],
        1
      ),
      _c("content-name", {
        staticClass: "lh22 text-26 word-break",
        class: { block: !_vm.fromHor },
        attrs: { code: _vm.code, name: _vm.name },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }